import React from "react";
import "../Quality/Quality.css";
// import ISO_9001 from "../Assets/ISO-9001-1.png";

function Quality() {
  return (
    <>
      <div className="quality">
      <div className="approved">
            {/* <span > */}
              "State of the art WHO-GMP, ISO 9001:2008 and NPCB, PIC/S Malaysia
              approved manufacturing facility."
            {/* </span> */}
            </div>
        <h1 className="quality-title">
          {" "}
          Quality Management
        </h1>

        <div className="quality-top-container">
          <div className="quality-left-side">
            <h3>Medisol's quality is achieved through</h3>
            <p>
              <ul>
                <li>
                  Sound basic attitude to quality and personal commitment in all
                  levels.
                </li>
                <li>Integrated comprehension of formulations processes.</li>
                <li>
                  Constant focus on improvements of manufacturing systems.
                </li>
              </ul>
              Quality Management is to manage any activity that can influence
              the quality of our products, where our Quality Control (QC) system
              is concerned with the daily routine activities related to the
              production and release of finished goods, our Quality Assurance
              (QA) system has been established to ensure:
              <ul>
                <li>A consistent level of quality</li>
                <li>That quality problems are sought prevented</li>
                <li>
                  That our inhalation products are of good acceptable quality
                </li>
              </ul>
              Therefore, we have fully incorporated the requirements of current
              GDP (Good Distribution Practice) in our Quality system and further
              added particular elements required when working in a field, where
              prequalification and product quality are essential factors.
              <br />
              <br />
              The processes forming part of our quality system are described in
              detailed SOPs (Standard Operating Procedures) and relate to our QA
              activities as well as our QC activities.
            </p>
          </div>
          <div className="quality-right-side">
              {/* <img src={ISO_9001} alt="" className="quality-image"/> */}
              {/* <p className="quality-approved">
                "State of the art WHO-GMP, ISO 9001:2008 and NPCB, PIC/S
                Malaysia approved manufacturing facility."
              </p> */}
          </div>
        </div>
         <div className="quality-bottom-container">
         <h3>QUALITY POLICY </h3>
         <p>"The company accepts responsibility for the complete satisfaction of its customers with manufacturing and marketing best Quality Drug Products, which are eco-friendly and will satisfy continuing needs of our customers. We exercise this responsibility through the application of sound Quality Management System and adopting current Good Manufacturing Practices complying with all regulatory requirements.<br/><br/>We consider our human resources as one of the biggest asset. Our qualified and trained staff is provided constant training to upgrade their knowledge and stay conversant with state of art technology. The Quality Assurance of our products is the obligation of the company and all the departments of the company share it by keeping vigil while purchasing, manufacturing, and testing, distribution and marketing of its products".</p>
         </div>
      </div>
    </>
  );
}
export default Quality;
